import {
  IWorkOrder,
  IInsertWorkOrderRequest,
  IServiceTodo,
  IUpdateWorkOrderOfficeRequest,
  IUpdateWorkOrderTechRequest,
  IGetWorkOrderRequest,
  IGetWorkOrderResponse,
  IUpdateWorkOrderTechReponse,
  IGetWorkOrdersListResponse,
  IInsertWorkOrderReponse,
  IUpdateWorkOrderOfficeReponse,
  ITransferWorkOrderRequest,
  ITransferWorkOrderResponse,
  ISetWorkOrderStatusRequest,
  ISetWorkOrderStatusResponse,
	IGetWorkOrdersListRequest,
	IWorkOrderFilter,
	ILeftVoiceMailReponse,
	ILeftVoiceMailRequest
} from "@/interfaces";
import { AxiosResponse } from "axios";
import Vue from "vue";
import store from "@/vuex/store";

export const GetWorkOrders = async (filter?: IWorkOrderFilter): 
Promise<IGetWorkOrdersListResponse> => {

	const req: IGetWorkOrdersListRequest = {
		 Filter: filter
	};

  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
		data: req,
    params: {
      action: "get-work-order-list"
    }
  });
  return resp.data;
};

export const InsertWorOrder = async (
  worOrder: IWorkOrder,
  services: IServiceTodo[]
): Promise<IInsertWorkOrderReponse> => {
  const insertWorkOrderRequest: IInsertWorkOrderRequest = {
    WorkOrder: worOrder,
    Services: services
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: insertWorkOrderRequest,
    params: {
      action: "insert-work-order"
    }
  });
  return resp.data;
};

export const UpdateWorOrderOffice = async (
  worOrder: IWorkOrder,
  services: IServiceTodo[]
): Promise<IUpdateWorkOrderOfficeReponse> => {
  const updateWorkOrderRequest: IUpdateWorkOrderOfficeRequest = {
    WorkOrder: worOrder,
    Services: services
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: updateWorkOrderRequest,
    params: {
      action: "update-work-order-office"
    }
  });
  return resp.data;
};

export const UpdateWorOrderTech = async (
  worOrder: IWorkOrder,
  services: IServiceTodo[]
): Promise<IUpdateWorkOrderTechReponse> => {
  const updateWorkOrderRequest: IUpdateWorkOrderTechRequest = {
    WorkOrderID: worOrder.RecordID!,
    Services: services
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: updateWorkOrderRequest,
    params: {
      action: "update-work-order-tech"
    }
  });
  return resp.data;
};

export const GetWorOrder = async (
  id: number
): Promise<IGetWorkOrderResponse> => {
  const getWorkOrderRequest: IGetWorkOrderRequest = {
    WorkOrderID: id
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: getWorkOrderRequest,
    params: {
      action: "get-work-order"
    }
  });
  return resp.data;
};


export const LeftVoiceMail = async (
  id: number, 
	lvm: boolean,
): Promise<ILeftVoiceMailReponse> => {
  const req: ILeftVoiceMailRequest = {
    WorkOrderID: id,
		LVM: lvm,
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: req,
    params: {
      action: "lvm-work-order"
    }
  });
  return resp.data;
};

export const TransferWorOrder = async (
  data: ITransferWorkOrderRequest
): Promise<ITransferWorkOrderResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data,
    params: {
      action: "transfer-work-order"
    }
  });
  return resp.data;
};

export const SetWorkOrderStatus = async (
  data: ISetWorkOrderStatusRequest
): Promise<ISetWorkOrderStatusResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data,
    params: {
      action: "set-work-order-status"
    }
  });
  return resp.data;
};
